module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"displayName":"@:labels.displayName","firstname":"@:labels.firstname","lastname":"@:labels.lastname","required":"@:labels.required","save":"@:labels.save","title":"@:labels.profile"},"fr":{"displayName":"@:labels.displayName","firstname":"@:labels.firstname","lastname":"@:labels.lastname","required":"@:labels.required","save":"@:labels.save","title":"@:labels.profile"}}')
  delete Component.options._Ctor
}
